import { searchableRoles } from '../enums/user-role-name.enum';
import { keyBy } from 'lodash-es';

const userRoleOptions = searchableRoles.map(({name, humanizedName}) => (
  {value: name, display: humanizedName}
))

export const keyedUserRoleOptions = keyBy(userRoleOptions, 'value');
